import moment from 'moment';

const MONTHS_PT = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];

const MONTHS_PT_FULL = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export const academyDay = (date: string): string => moment(date).format('DD');

export const academyMonthAbbr = (date: string): string => MONTHS_PT[moment(date).month()];

export const academyMonthLabel = (date: string): string => {
  const m = moment(date);
  return `${MONTHS_PT_FULL[m.month()]}/${m.year()}`;
};

export const academyMonthKey = (date: string): string => moment(date).format('YYYY-MM');

const WEEKDAYS_PT = [
  'Domingo',
  'Segunda-feira',
  'Terça-feira',
  'Quarta-feira',
  'Quinta-feira',
  'Sexta-feira',
  'Sábado',
];

// Ex.: "Quinta-feira - 18/06/2026 às 19h"
export const academyDateTimeLabel = (date: string): string => {
  const m = moment(date);
  const weekday = WEEKDAYS_PT[m.day()];
  const time = m.minute() === 0 ? `${m.format('HH')}h` : m.format('HH:mm');
  return `${weekday} - ${m.format('DD/MM/YYYY')} às ${time}`;
};

// Ex.: "Quinta-feira às 19h"
export const academyWeekdayTimeLabel = (date: string): string => {
  const m = moment(date);
  const weekday = WEEKDAYS_PT[m.day()];
  const time = m.minute() === 0 ? `${m.format('HH')}h` : m.format('HH:mm');
  return `${weekday} às ${time}`;
};

// Ex.: "Começa em 3 dias", "Amanhã", "Hoje", "Ao vivo agora"
export const academyCountdownLabel = (date: string, isLive: boolean): string => {
  if (isLive) return 'Ao vivo agora';
  const days = moment(date).startOf('day').diff(moment().startOf('day'), 'days');
  if (days <= 0) return 'Hoje';
  if (days === 1) return 'Amanhã';
  return `Começa em ${days} dias`;
};
